'use strict';

define('vb/private/events/eventModel',[
  'vb/private/events/baseEventModel',
  'vb/private/events/eventBehaviorFactory',
], (BaseEventModel, EventBehaviorFactory) => {
  /**
   * @typedef {import('vb/private/stateManagement/container').default} Container
   * @typedef {import('vb/private/events/eventRegistry').default} EventRegistry
   */

  /**
   * Represents a standard VB event model.
   *
   * This class extends the BaseEventModel and provides additional functionality specific to VB events.
   * It includes properties such as name, registry, definition, container, and behavior.
   *
   * @extends BaseEventModel
   */
  class EventModel extends BaseEventModel {
    /**
     * Creates an instance of EventModel.
     *
     * @param {String} name - The name of the event.
     * @param {EventRegistry} registry - The event registry associated with the event.
     * @param {Object} [definition] - The JSON declaration of the event, containing properties below.
     * @param {String} [definition.behavior] - The behavior type of the event (e.g., 'notify', 'notifyAndWait',
     * 'checkForCancel', 'transform' (deprecated), 'transformPayload', 'dynamicComponent').
     * @param {String} [definition.propagationBehavior] - The propagation behavior type for fragment and layout events
     * only. Possible values are 'self' (default) or 'container'
     * @param {String} [definition.mode] - The mode of the event (e.g., 'listenable', 'triggerable').
     * @param {String} [definition.autoWire] - The auto-wired event listener name.
     * @param {Object} [definition.payloadType] - The expected type of the event payload.
     * @param {Object} [definition.returnType] - The expected return type of the event.
     * @param {Container|null} [container] - The declaring container, or null if not declared.
     * @param {boolean} [isInterface=false] - Whether the event is declared in the container's interface section.
     */
    constructor(name, registry, definition, container, isInterface = false) {
      super(name, registry, definition, container, isInterface);

      // VB Events must have a behavior
      this.eventBehavior = EventBehaviorFactory.create(name, this, registry);
    }
  }

  return EventModel;
});

